import BirthdayInput from 'components/birthday-input'
import LegalAge from 'components/legal-age'
import useMainClass from 'hooks/use-main-cass'
import { useAgegate } from 'hooks/use-agegate'
import useRedirect from 'hooks/use-redirect'
import useRouter from 'hooks/use-router'
import { useContext, useEffect } from 'react'
import CONFIGS from 'build/Config'
import { LoaderContext } from 'contexts/loader-context'

function Agegate() {
  const { setAgeLocal, showAgegate, isMinor } = useAgegate()
  const { setFooter, setHead } = useContext(LoaderContext)

  const [{ url }, { redirect }] = useRedirect()
  const { push } = useRouter()

  useMainClass('agegate')

  useEffect(() => {
    if (CONFIGS?.versionPh) {
      setFooter(false)
      setHead(false)
    }

    return () => {
      if (CONFIGS?.versionPh) {
        setFooter(true)
        setHead(true)
      }
    }
  }, [])

  useEffect(() => {
    if (showAgegate && !isMinor) {
      if (url) return redirect()
      push('/start')
    } else if (showAgegate && isMinor && !CONFIGS?.versionPh) {
      push('/agegate')
    }
  }, [showAgegate, isMinor])

  if (CONFIGS.legalAgeDate) {
    return <BirthdayInput isMinor={isMinor} setAgeLocal={setAgeLocal} />
  }

  return <LegalAge setAgeLocal={setAgeLocal} />
}

export default Agegate
